import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import keys from 'lodash/keys';
import { stringify } from 'qs';
import * as TYPES from './types';
import { extractProductReference } from '~/helpers/extract-helper';
import { fetchProduct, fetchProductCarousels } from '~/services/product';
export default {
  fetchProductCarousels(_ref, _ref2) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref;
      var {
        alias,
        profileId,
        exclude,
        isPrivateSales = false
      } = _ref2;
      var reference = extractProductReference(alias);
      var product = yield fetchProductCarousels(_this, reference, profileId, exclude, isPrivateSales);
      commit(TYPES.SET_PRODUCT_CAROUSELS, product);
    })();
  },
  fetchProduct(_ref3, _ref4) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      var {
        commit
      } = _ref3;
      var {
        alias,
        query,
        profileId,
        isPrivateSales = false
      } = _ref4;
      var reference = extractProductReference(alias);
      var product = yield fetchProduct({
        context: _this2,
        reference,
        offer: query.offer,
        profileId,
        isPrivateSales
      });
      var {
        currentLocale
      } = _this2.state.i18n;
      var currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
      var currentAlias = "".concat(product.slug, "-").concat(product.reference, ".htm");
      if (alias !== currentAlias && process.server) {
        _this2.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/p/").concat(currentAlias).concat(currentQuery));
      }
      var redirectUrl = product && product.redirection && product.redirection.redirectUrl;
      if (redirectUrl && redirectUrl !== '#') {
        if (process.server) {
          var redirectCode = product.redirection.redirectHttpCode || 301;
          _this2.app.context.redirect(redirectCode, redirectUrl);
        } else {
          window.location.href = "".concat(redirectUrl).concat(currentQuery);
        }
      }
      commit(TYPES.SET_PRODUCT, product);
    })();
  }
};